import {
    TOKENGOOGLE_ERROR,
    TOKENGOOGLE_LOADING,
    TOKENGOOGLE_SUCCESS,
    TOKENGOOGLE_LOGOUT,
    RESET_PORTAL_CONTEXT,
  } from "../ActionTypes";
  
  import tokenGoogleInitialState from "../initialStates/accessTokenInitialState";
  
  const tokenGoogle = (state, { payload, type }) => {
    switch (type) {
      case TOKENGOOGLE_LOADING:
        return {
          ...state,
          tokenGoogle: {
            ...state.tokenGoogle,
            error: false,
            loading: true,
          },
        };
      case TOKENGOOGLE_SUCCESS:
        return {
          ...state,
          tokenGoogle: {
            ...state.tokenGoogle,
            loading: false,
            error: false,
            data: payload,
          },
        };
      case TOKENGOOGLE_ERROR:
        return {
          ...state,
          tokenGoogle: {
            ...state.tokenGoogle,
            error: payload,
            loading: false,
          },
        };
  
      case TOKENGOOGLE_LOGOUT:
        return tokenGoogleInitialState;
        
      case RESET_PORTAL_CONTEXT:
        return tokenGoogleInitialState;
  
      default:
        return state;
    }
  };
  
  export default tokenGoogle;